module.exports = __webpack_public_path__ + "img/ayudaeconomica.29fc1e94.png";